const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isStandalone = !!(iOS && window.navigator.standalone);

export default (theme) => ({
  dialogRoot: {
    [theme.breakpoints.up('sm')]: {
      width: 550,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 5,
    },
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 8px 8px',
    '& > h2': {
      fontSize: '1.6rem',
    }
  },
  text: {
    display: 'flex',
    justifyContent: 'center',
    '& > h5': {
      // fontSize: '1.4rem',
      textAlign: 'center',
      fontWeight: '500',
      lineHeight: '1.8rem',
    }
  },
  content: {
    color: theme.palette.textColor.dark,
    fontSize: 14,
    fontWeight: 500,
    padding: '5px 0',
  },
  closeButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
  },
  button: {
    color: theme.palette.primary.blue,
    border: theme.palette.primary.blue,
    background: '#fff',
    '&:hover': {
      color: '#fff',
      background: '#1976D2! important',
    },
    '&:focus': {
      color: '#fff',
      background: `${theme.palette.primary.blue} !important`,
    },
  },
  radio: {
    padding: '8px',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    '& label': {
      width: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      '& span': {
        fontSize: '0.9rem',
        fontWeight: 'normal',
      },
      '&:first-child': {
        flexBasis: '160px',
        justifyContent: 'left',
      }
    },
  },
  buttonHolder: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  cancelButton: {
    margin: 10,
    minWidth: 140,
    padding: '7px 0px',
    '&:hover': {
      color: theme.palette.textColor.dark,
    },
    '&:focus': {
      color: theme.palette.textColor.dark,
      backgroundColor: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#fff',
    },
  },
  saveButton: {
    margin: 10,
    minWidth: 140,
    padding: '7px 0px',
    '&:hover': {
      color: theme.palette.textColor.primary,
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
      backgroundColor: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#fff',
    },
  },
});
